import React, { useEffect, useState } from 'react';
import classes from "./Language.module.css";
import BottomNavbar from '../components/BottomNavbar';
import { FaArrowLeft } from "react-icons/fa6";
import Header from '../components/Header';
import { languages } from '../utils/languages';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../store/slices/languageSlice';
import SubLayout from '../components/SubLayout';

const Language = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { selectedLanguage } = useSelector(state => state?.languageSlice);
    const dispatch=useDispatch();

    useEffect(() => {
        if (selectedLanguage) {
            i18n.changeLanguage(selectedLanguage);
        }
    }, [selectedLanguage, i18n])
    return (
        <>
            {/* <Header /> */}
            <SubLayout>

            {/* <div className={classes.container}> */}

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate(-1);
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("21")}</h2>
                </div>

                <p className={classes.label_text}>{t("26")}</p>

                {languages.map(lang => (
                    <div key={lang.id} className={classes.language_container} onClick={() => dispatch(setLanguage(lang.id))}>
                        <label htmlFor={lang.id} className={classes.language_label}>{lang.name}</label>
                        <input id={lang.id} type="radio" name="r" value={lang.id} checked={selectedLanguage == lang.id} />
                    </div>
                ))}

            </SubLayout>

            {/* </div> */}

            <BottomNavbar active={4} />
        </>
    )
}

export default Language